import { Component, input } from '@angular/core';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import {
  AnyChallenge,
  UnselectionButtonFirstVariantConfig,
} from '@shared/models';

import { UnselectionButtonBaseClass } from '../unselection-button.base.class';

@Component({
  selector: 'b2c-variant1',
  imports: [ElementDirective],
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
})
export class Variant1Component extends UnselectionButtonBaseClass {
  challenge = input.required<AnyChallenge>();
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
  config = input.required<UnselectionButtonFirstVariantConfig>();
}
